const initAskEmbed = (askBtn) => {
    const body = document.querySelector(".js-body");
    const embedEl = document.querySelector(".js-embed");

    const stopScrollingClass = 'stop-scrolling';
    const isActiveClass = 'embed-is-active';
    let embedActive = false;

    askBtn.addEventListener("click", (e) => {
        e.preventDefault();
        embedActive = true;

        body.classList.add(stopScrollingClass, isActiveClass);
    });

    embedEl.addEventListener('click', (e) => {
        if (!e.target.closest('.ask-embed__iframe-wrapper')) {
            body.classList.remove(stopScrollingClass, isActiveClass);
            embedActive = false;
        }
    });
};

export { initAskEmbed as default };
